// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueScrollTo from 'vue-scrollto';
import BootstrapVue from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import VueDisqus from 'vue-disqus'
import VueTour from 'vue-tour'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueMeta from 'vue-meta';

require('vue-tour/dist/vue-tour.css')

Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.use(VueTheMask);
Vue.use(VueScrollTo);
Vue.use(money, {precision: 4});
Vue.use(VueDisqus);
Vue.use(VueTour)
Vue.use(VueMeta);
Vue.component(VueQrcode.name, VueQrcode);
// Vue.use(require('prerender-node').set('prerenderToken', '2BwGZ7P2XuYBz5HCyMxO'));

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js